import { FaCheck, FaPlusCircle } from 'react-icons/fa';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
    clearCart,
    resetIsCompleteCart,
    setCartItems,
    setCartOpenState,
    setCurrentStep,
    setIsAllItemsCompleteCart,
} from 'features/cart/cartSlice';
import './CartForm.css';
import { CartItemSide } from 'components/cartItemSide';
import {
    CartContactForm,
    SkeletonCartMobileForm,
} from 'components/cartContactForm';
import { CartAddOnWrapper } from 'components/cartAddOnWrapper';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import { apiConfig } from 'config';
import { SkeletonCartForm } from '.';
import CartItemsMobileButton from 'components/cartItemsMobileButton/CartItemsMobileButton';
import { isEqual } from 'lodash';
const CartForm = ({ extraClass = '', isMobile = false }) => {
    const dispatch = useDispatch();

    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const currentStep = useSelector((state) => state.cart?.currentStep);
    const isCartCompleted = useSelector((state) => state.cart?.isCartCompleted);
    const items = useSelector((state) => state.cart?.cartItems);
    const firstIncompleteIndex = items.findIndex((item) => !item.isCompleted);
    const cartID = useSelector(
        (state) => state.miniBookingWidget?.data?.cartID
    );
    const propCode = useSelector(
        (state) => state.miniBookingWidget?.data?.propCode
    );

    const [hasCartExtras, setHasCartExtras] = useState(false);
    const [isFetching, setIsFetching] = useState(true);

    const changeCartFormState = (state) => {
        dispatch(setCartOpenState(state));
        if (isCartCompleted) {
            dispatch(clearCart(state));
        }
    };
    useEffect(() => {
        if (!hasCartExtras) {
            dispatch(resetIsCompleteCart());
            dispatch(setCurrentStep({ currentStep: 1 }));
        }
    }, []);
    let step1Class = '';
    let step2Class = '';
    let step3Class = '';
    if (currentStep === 1) {
        step1Class = 'ab-active';
    } else if (currentStep === 2) {
        step2Class = 'ab-active';
        step1Class = 'ab-go-back';
    } else if (currentStep === 3) {
        step3Class = 'ab-active';
    }

    useEffect(async () => {
        const checkCart = async () => {
            try {
                setIsFetching(true);
                const response = await axios.post(apiConfig?.getCart, {
                    cartID,
                    propCode,
                });

                return response?.data;
            } catch (error) {
                toast.error(Lang?.networkError, {
                    autoClose: true,
                    theme: 'colored',
                });
            }
            setIsFetching(false);
        };
        const fetchAddOns = async () => {
            try {
                setIsFetching(true);
                const response = await axios.post(apiConfig?.checkAddOns, {
                    cartID,
                    propCode,
                });

                if (response?.data?.toLowerCase() === 'ok') {
                    setHasCartExtras(true);
                } else {
                    dispatch(setCurrentStep({ currentStep: 2 }));
                    dispatch(setIsAllItemsCompleteCart());
                }
            } catch (error) {
                toast.error(Lang?.networkError, {
                    autoClose: true,
                    theme: 'colored',
                });
            }
            setIsFetching(false);
        };
        const checkCartResponse = await checkCart();
        if (checkCartResponse?.isSomethingDifferent) {
            if (isEqual(items, checkCartResponse?.cartItems) === false) {
                toast.error(Lang?.someChangesInYourCart, {
                    autoClose: true,
                    theme: 'colored',
                });
            }
            dispatch(setCartItems(checkCartResponse?.cartItems));
            if (checkCartResponse?.cartItems.length === 0) {
                changeCartFormState(false);
            }
        }
        fetchAddOns();
    }, []);

    return (
        <>
            {!isFetching ? (
                <div
                    className={`ab-room-info-page ${extraClass} ${
                        isMobile ? 'cart-mobile-form' : ''
                    }`}
                >
                    <div className="ab-column">
                        <div
                            className={`ab-body-inner-header ab-search-filters-wrapper`}
                            style={{ height: '93px' }}
                        >
                            <div
                                className={`ab-steps-line-cart ${
                                    !hasCartExtras
                                        ? 'ab-steps-line-cart-small'
                                        : ''
                                }`}
                            >
                                <div
                                    className={`ab-line-step-cart ab-go-back`}
                                    onClick={() => changeCartFormState(false)}
                                >
                                    <div className="ab-step-dot ab-step-back">
                                        1
                                    </div>
                                    <div
                                        className="ab-step-text"
                                        style={{
                                            textTransform: 'capitalize',
                                        }}
                                    >
                                        {!isMobile ? (
                                            <>
                                                {Lang.backTo}{' '}
                                                {Lang.roomSelection} 1/1
                                            </>
                                        ) : (
                                            <>{Lang?.back} </>
                                        )}
                                    </div>
                                </div>
                                {hasCartExtras && (
                                    <div
                                        className={`ab-line-step-cart ${step1Class}`}
                                        onClick={() => {
                                            if (currentStep === 2) {
                                                dispatch(resetIsCompleteCart());
                                                dispatch(
                                                    setCurrentStep({
                                                        currentStep: 1,
                                                    })
                                                );
                                            }
                                        }}
                                    >
                                        <div className="ab-step-dot">2</div>
                                        <div className="ab-step-text">
                                            {!isMobile ? (
                                                <>
                                                    {Lang?.addOns} /{' '}
                                                    {Lang?.extras}
                                                </>
                                            ) : (
                                                <>{Lang?.extras}</>
                                            )}
                                        </div>
                                    </div>
                                )}

                                <div
                                    className={`ab-line-step-cart ${step2Class}`}
                                >
                                    <div className="ab-step-dot">
                                        {hasCartExtras ? 3 : 2}
                                    </div>
                                    <div className="ab-step-text">
                                        {!isMobile ? (
                                            <>{Lang.billingInformation}</>
                                        ) : (
                                            <>Checkout</>
                                        )}
                                    </div>
                                </div>
                                <div
                                    onClick={() =>
                                        dispatch(
                                            setCurrentStep({ currentStep: 1 })
                                        )
                                    }
                                    className={`ab-line-step-cart ${step3Class}`}
                                >
                                    <div className="ab-step-dot">
                                        <FaCheck />
                                    </div>
                                    <div className="ab-step-text">
                                        {Lang.confirm}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            className={`ab-cart-wrapper ${
                                isMobile ? 'mobile-addons' : ''
                            }`}
                        >
                            {!isMobile ? (
                                <div className="ab-cart-right-side">
                                    <div className="ab-cart-right-side-top">
                                        <CartItemSide
                                            extraClass={`${
                                                currentStep !== 1 &&
                                                'ab-some-extra-room'
                                            }`}
                                            hasCartExtras={hasCartExtras}
                                        />
                                    </div>
                                    <div
                                        onClick={() =>
                                            changeCartFormState(false)
                                        }
                                        className="ab-cart-right-side-top-bottom"
                                    >
                                        <FaPlusCircle />
                                        <span>
                                            {' '}
                                            {Lang?.addAnotherRoom
                                                .replace('Ά', 'Α')
                                                .replace('Έ', 'Ε')}
                                        </span>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    {currentStep !== 3 && (
                                        <CartItemsMobileButton />
                                    )}
                                </>
                            )}

                            {currentStep === 1 ? (
                                <>
                                    <div
                                        className={`${
                                            isMobile
                                                ? 'ab-cart-addon-mobile'
                                                : 'ab-cart-left-side'
                                        }`}
                                    >
                                        <div className="ab-cart-add-on-general-title">
                                            {Lang?.chooseAddOns}{' '}
                                            {Lang?.forTxt.toLowerCase()}{' '}
                                            {Lang?.Room}{' '}
                                            {firstIncompleteIndex + 1}
                                        </div>
                                        <div className="ab-cart-separate-line"></div>
                                        <div className="ab-cart-add-on">
                                            <CartAddOnWrapper
                                                isMobile={isMobile}
                                            />
                                        </div>
                                    </div>
                                </>
                            ) : currentStep >= 2 ? (
                                <CartContactForm />
                            ) : null}
                        </div>
                    </div>
                </div>
            ) : !isMobile ? (
                <SkeletonCartForm />
            ) : (
                <SkeletonCartMobileForm />
            )}
        </>
    );
};

CartForm.propTypes = {
    extraClass: PropTypes.string,
    isMobile: PropTypes.bool,
};

export default CartForm;
